export default {"src":"/_next/static/media/facebook-logo.5f0a3fe1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};